// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiple-choice-one-or-many-answers[data-v-5900f8a9]{display:flex;flex-direction:row;align-items:flex-start}.bolded[data-v-5900f8a9]{font-weight:800}.selected-image[data-v-5900f8a9]{border:5px solid #000}", ""]);
// Exports
module.exports = exports;
